<script lang="ts">
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';

    export let heading: string;
    export let printButtonLabel: string;
    export let printDisabled = false;
</script>

<div class="optimisation-overview-heading">
    <span class="overview-heading">{heading}</span>

    <div class="print-button-container">
        <KpButton isDisabled={printDisabled} buttonStyle="accent-blue-new" on:click>
            <IconedContent icon="print">{printButtonLabel}</IconedContent>
        </KpButton>
    </div>
</div>

<style lang="less">
    .optimisation-overview-heading {
        display: flex;
        justify-content: space-between;
        align-items: end;

        .overview-heading {
            font-weight: 500;
        }
    }
</style>